export const Marquee = ({ items }) => (
  <div
    data-testid="editorial-marquee"
    className="marquee relative overflow-hidden border-y border-ink/10 bg-sand py-5"
  >
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((copy) => (
        <div
          key={copy}
          aria-hidden={copy === 1}
          className="flex items-center whitespace-nowrap"
        >
          {items.map((it, i) => (
            <span
              key={i}
              className="flex items-center font-display text-lg md:text-xl uppercase tracking-[0.18em] text-ink/70"
            >
              <span className="px-8">{it}</span>
              <span className="inline-block h-2 w-2 rotate-45 bg-gold" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
